/**
 *
 * Asynchronously loads the component for RingWithGuides
 *
 */

import { lazyLoad } from 'utils/loadable';

export const RingWithGuides = lazyLoad(
  () => import('./index'),
  module => module.RingWithGuides,
);
